<div class="tutorial" *ngIf="data">
    <finder-component-header *ngIf="data | hasText" [data]="data"></finder-component-header>
    <div class="tutorial-items" [finderMultipleItemsPerRow]="data.maxItemsPerRow"
        [finderHasTabletColumns]="data.hasTabletColumns">
        <ng-container *ngFor="let item of data.items; let i = index">
            <finder-polyline *ngIf="item.polyline || item.mobilePolyline"
                [polyline]="item.polyline"
                [mobilePolyline]="item.mobilePolyline">
            </finder-polyline>
            <div class="tutorial-item"
                [ngClass]="item.style"
                [class.custom-margin]="!(item.media | isMeMedia)"
                [finderScrollTo]="item.id + '-' + (i + 1)"
            >
                <div class="tutorial-media">
                    <finder-media-gallery *ngIf="item.media | isMeMedia"
                        [config]="item.gallery"
                    ></finder-media-gallery>
                    <!-- Check that `item.media` is an array and has a `type` property -->
                    <ng-container *ngIf="!(item.media | isMeMedia)">
                        <!-- Properties MUST be bound this way or they do not work -->
                        <video *ngIf="item.media[0]?.desktop | isVideo"
                            [autoplay]="true"
                            [loop]="true"
                            [muted]="true"
                            playslinline
                        ><source [src]="item.media[0]?.desktop?.url">
                        </video>
                        <finder-picture *ngIf="!(item.media[0]?.desktop | isVideo)"
                            [picture]="item.media[0]"
                        ></finder-picture>
                    </ng-container>
                </div>
                <finder-generic-text *ngIf="item | hasText"
                    class="tutorial-text"
                    [data]="item"
                ></finder-generic-text>
            </div>
        </ng-container>
    </div>
</div>
